export default __webpack_public_path__ + "static/media/slide.df4750f5.svg";